import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=7da2151d"
import script from "./FileAttachment.vue?vue&type=script&lang=js"
export * from "./FileAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports